/**
 * Copyright 2025 Nordcloud Oy or its affiliates. All Rights Reserved.
 */

import { ExtendedTooltipProps } from "@nordcloud/gnui/dist/components/extendedTooltip/ExtendedTooltip";
import { theme } from "@nordcloud/gnui";
import { SvgName } from "~/tools/types";

export const duplicateIconConfig: {
  icon: SvgName;
  color: string;
  tooltip: string;
  tooltipPlacement: ExtendedTooltipProps["placement"];
} = {
  icon: "info",
  color: theme.color.text.info,
  tooltip: "Duplicate",
  tooltipPlacement: "top",
};
